import startersFile from "../config/assistant-starters.json" with { type: "json" };
const parsed = startersFile;
/** CEO Command Assistant empty-state starters (app config, not DynamoDB). */
export const ASSISTANT_STARTERS = parsed.starters;
//# sourceMappingURL=assistant-starters.js.map